/* eslint-disable camelcase */
/* eslint-disable unicorn/consistent-destructuring */
import QueryColumn from '~/scripts/services/model/query-column';

const makeDefault = (linker_info, linker_kid, nodeName, $translate) => {
	const linker = (linker_info && linker_kid !== '0') ? ` :: ${linker_info.name}` : '';
	return `${$translate ? $translate.instant(nodeName) : nodeName}${linker}`;
};

/**
 * @param {QueryColumn} column
 * @param {?angular.translate.ITranslateService} $translate
 * @returns {string} Column name
 */
export function makeNodeName(column, $translate = null) {
	const { name: nodeName, linker_info, linker_kid } = column;

	// If we have a custom representation, use it
	if (column?.settings?.titleRepresentation) {
		if (column.settings.titleRepresentation === 'custom') {
			if (column.settings.label) {
				return column.settings.label;
			}
		}
		else if (column.settings.titleRepresentation === 'default') {
			return makeDefault(linker_info, linker_kid, nodeName, $translate);
		}
		else {
			return column.settings.titleRepresentation.value;
		}
	}
	else if (column?.kdata?.label) {
		return column.kdata.label;
	}
	return makeDefault(linker_info, linker_kid, nodeName, $translate);
}
